import CompraItemService from "@/services/CompraItemService";

export const compraItem = {
  namespaced: true,
  state: {
    compraItem: {},
  },
  actions: {
    getCompraItemOData({ commit }, payload) {
      return CompraItemService.GetCompraItemOData(payload).then(
        (compraItem) => {
          return Promise.resolve(compraItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default compraItem;
